<template>
  <div class="container">
    <div class="row">
      <div v-if="showRecommendedDevices">
        <div class="col-12 mt-5 mb-3">
          <h1 id="titleRecommendedDevices" class="text-center">
            {{ t("SS_SURVEY_RECOMMENDED_DEVICE") }}
          </h1>
        </div>
        <!-- START CARD -->
        <div class="card mb-3">
          <div class="row g-0">
            <div class="col-md-12">
              <div class="card-body">
                <h1 class="card-title text-center">
                  {{ recommendedDevice?.manufacturer }}
                  {{ recommendedDevice?.family }}
                </h1>
                <Spinner v-if="showRecommendedDeviceSpecsLoader" />
                <div
                  class="row align-items-center"
                  v-show="showRecommendedDeviceSpecs"
                >
                  <div class="col-6">
                    <div
                      class="row pb-3 align-items-center device-spec"
                      v-show="
                        recommendedDevice?.cameraFront ||
                        recommendedDevice?.cameraBack
                      "
                    >
                      <div class="col-4 text-center ps-0">
                        <img
                          class="img-fluid p-0"
                          :src="iconCamera"
                          alt="front camera"
                        />
                      </div>
                      <div class="col-8 justify-content-start ps-0">
                        <span
                          id="recommendedDeviceFrontCamera"
                          class="fs-5 pb-2 align-self-center"
                          v-show="recommendedDevice?.cameraFront"
                        >
                          {{
                            t("SS_SURVEY_DEVICE_FRONT_CAMERA_SPEC", {
                              CAMERA_SPEC: recommendedDevice?.cameraFront,
                            })
                          }}
                        </span>
                        <br />
                        <span
                          id="recommendedDeviceBackCamera"
                          class="fs-5 align-self-center"
                          v-show="recommendedDevice?.cameraBack"
                        >
                          {{
                            t("SS_SURVEY_DEVICE_BACK_CAMERA_SPEC", {
                              CAMERA_SPEC: recommendedDevice?.cameraBack,
                            })
                          }}
                        </span>
                      </div>
                    </div>
                    <div
                      class="row pb-3 align-items-center device-spec"
                      v-show="recommendedDevice?.storage"
                    >
                      <div class="col-4 text-center ps-0">
                        <img
                          class="img-fluid"
                          :src="iconStorage"
                          alt="internal storage"
                        />
                      </div>
                      <div class="col-8 justify-content-start ps-0">
                        <span
                          id="recommendedDeviceStorage"
                          class="fs-5 align-self-center"
                        >
                          {{
                            t("SS_SURVEY_DEVICE_STORAGE_SPEC", {
                              STORAGE_SPEC: recommendedDevice?.storage,
                            })
                          }}
                        </span>
                      </div>
                    </div>
                    <div
                      class="row pb-3 align-items-center device-spec"
                      v-show="recommendedDevice?.battery"
                    >
                      <div class="col-4 text-center ps-0">
                        <img
                          class="img-fluid"
                          :src="iconBattery"
                          alt="battery"
                        />
                      </div>
                      <div class="col-8 justify-content-start ps-0">
                        <span
                          id="recommendedDeviceBattery"
                          class="fs-5 align-self-center"
                        >
                          {{
                            t("SS_SURVEY_DEVICE_BATTERY_SPEC", {
                              BATTERY_SPEC: recommendedDevice?.battery,
                            })
                          }}
                        </span>
                      </div>
                    </div>
                    <div
                      class="row pb-3 align-items-center device-spec"
                      v-show="recommendedDevice?.ram"
                    >
                      <div class="col-4 text-center ps-0">
                        <img class="img-fluid" :src="iconRam" alt="ram" />
                      </div>
                      <div class="col-8 justify-content-start ps-0">
                        <span
                          id="recommendedDeviceRam"
                          class="fs-5 align-self-center"
                        >
                          {{
                            t("SS_SURVEY_DEVICE_RAM_SPEC", {
                              RAM_SPEC: recommendedDevice?.ram,
                            })
                          }}
                        </span>
                      </div>
                    </div>
                    <div
                      class="row pb-3 align-items-center device-spec"
                      v-show="recommendedDevice?.displaySize"
                    >
                      <div class="col-4 text-center ps-0">
                        <img
                          class="img-fluid"
                          :src="iconDisplaySize"
                          alt="display size"
                        />
                      </div>
                      <div class="col-8 justify-content-start ps-0">
                        <span
                          id="recommendedDeviceDisplaySize"
                          class="fs-5 align-self-center"
                        >
                          {{
                            t("SS_SURVEY_DEVICE_DISPLAY_SIZE_SPEC", {
                              DISPLAY_SIZE_SPEC: recommendedDevice?.displaySize,
                            })
                          }}
                        </span>
                      </div>
                    </div>
                    <div
                      class="row align-items-center device-spec"
                      v-show="recommendedDevice?.displayResolution"
                    >
                      <div class="col-4 text-center ps-0">
                        <img
                          class="img-fluid"
                          :src="iconDisplayResolution"
                          alt="display resolution"
                        />
                      </div>
                      <div class="col-8 justify-content-start ps-0">
                        <span
                          id="recommendedDeviceDisplayResolution"
                          class="fs-5 align-self-center"
                        >
                          {{
                            t("SS_SURVEY_DEVICE_DISPLAY_RESOLUTION_SPEC", {
                              DISPLAY_RESOLUTION_SPEC:
                                recommendedDevice?.displayResolution,
                            })
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 text-center">
                    <img
                      v-show="recommendedDevice?.imageFront"
                      id="recommendedDeviceImage"
                      :src="recommendedDevice?.imageFront"
                      class="device-image rounded-start"
                      alt="device image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END CARD -->
        <div class="row">
          <div class="col text-center mb-3">
            <button
              id="next-step"
              class="btn btn-yellow fs-3 pj-ss-btn"
              @click="recommendedDeviceSelected()"
            >
              {{ t("SS_SURVEY_I_WANT_IT") }}
            </button>
          </div>
        </div>
        <div v-if="getMoreRecommendedDevices.length">
          <div class="row mt-5">
            <div class="col">
              <h6 class="fs-3">{{ t("SS_SURVEY_DEVICE_ALTERNATIVES") }}:</h6>
            </div>
          </div>
          <div class="row my-3">
            <div
              v-for="(device, index) in getMoreRecommendedDevices"
              :key="index"
              class="col"
            >
              <a href="#" @click="changeRecommendedDevice(index + 1)">
                <div class="text-center fs-4">
                  <span>
                    {{ device?.manufacturer }}
                    {{ device?.family }}
                  </span>
                </div>
                <div class="text-center">
                  <img
                    v-if="device.imageFront"
                    :src="device.imageFront"
                    class="secondary-device-image rounded-start"
                    alt="secondary device image"
                  />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="col-12 mt-5 mb-3">
        <h1 class="text-center">{{ t("SS_SURVEY_TITLE") }}</h1>
        <p class="fs-3">
          {{ t("SS_SURVEY_DESCRIPTION") }}
        </p>
      </div>

      <Question
        v-if="currentQuestion === 0"
        :title="getTitle"
        :options="getOptions"
        v-model="answers[currentQuestion]"
        @update:value="updateAnswer"
      />

      <Question
        v-if="currentQuestion === 1"
        :title="getTitle"
        :options="getOptions"
        v-model="answers[currentQuestion]"
        @update:value="updateAnswer"
      />

      <Question
        v-if="currentQuestion === 2"
        :title="getTitle"
        :options="getOptions"
        v-model="answers[currentQuestion]"
        @update:value="updateAnswer"
      />

      <div v-if="showRecommendedDevices" class="my-3">
        <div
          @click="emit('hideSurvey')"
          class="col fs-3 link-green text-center"
        >
          <a href="#">{{ t("SS_SURVEY_SEE_DEVICES_CATALOG") }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ActionLogs from "@/apps/merchant3/types/ActionLogEvents";
import { computed, ref } from "vue";
import EventLogs from "@/apps/merchant3/types/EventLogs";
import logEvent from "@/apps/merchant3/services/event-logs.service";
import logAction from "@/apps/merchant3/services/action-logs.service";
import Question from "@/apps/merchant3/components/self-onboarding/survey/Question.vue";
import useAsset from "@/apps/merchant3/shared-helpers/useAsset";
import { useI18n } from "@/apps/merchant3/composables/useI18n";
import { useStore } from "vuex";
import {
  getDeviceDetails,
  getRecommendedDevices,
} from "@/apps/merchant3/services/pricing.service";
import Spinner from "@/apps/merchant3/shared-components/ui/Spinner.vue";
import { IQuestion } from "@/apps/merchant3/types/SelfOnboarding/IQuestion";
import { IRecommendedDetailedDevice } from "@/apps/merchant3/types/SelfOnboarding/IRecommendedDetailedDevice";
import {
  surveyTransformerPrice,
  surveyTransformerSpecs,
} from "@/apps/merchant3/helpers/self-service/surveyTransformer";

const emit = defineEmits(["surveyDeviceChosen", "hideSurvey"]);

const { t } = useI18n();
const store = useStore();

const iconCamera = computed(() => useAsset("img/self-serve/camera.png"));
const iconStorage = computed(() => useAsset("img/self-serve/storage_spec.png"));
const iconBattery = computed(() => useAsset("img/self-serve/battery.png"));
const iconRam = computed(() => useAsset("img/self-serve/ram_spec.png"));
const iconDisplaySize = computed(() =>
  useAsset("img/self-serve/display_size.png")
);
const iconDisplayResolution = computed(() =>
  useAsset("img/self-serve/resolution.png")
);

const recommendedDeviceSelected = () => {
  emit("surveyDeviceChosen", recommendedDevice.value);
};

const currentQuestion = ref<number>(0);

const questions: IQuestion[] = [
  {
    title: t("SS_SURVEY_Q1_TITLE"),
    options: {
      0: t("SS_SURVEY_Q1_OPTION1"),
      1: t("SS_SURVEY_Q1_OPTION2"),
      2: t("SS_SURVEY_Q1_OPTION3"),
    },
  },
  {
    title: t("SS_SURVEY_Q2_TITLE"),
    options: {
      0: t("SS_SURVEY_Q2_OPTION1"),
      1: t("SS_SURVEY_Q2_OPTION2"),
      2: t("SS_SURVEY_Q2_OPTION3"),
    },
  },
  {
    title: `${t("SS_SURVEY_Q3_TITLE")}:`,
    options: {
      0: t("SS_SURVEY_Q3_OPTION1"),
      1: t("SS_SURVEY_Q3_OPTION2"),
      2: t("SS_SURVEY_Q3_OPTION3"),
    },
  },
];

const getTitle = computed(() => {
  return questions[currentQuestion.value].title;
});

const getOptions = computed(() => {
  return questions[currentQuestion.value].options;
});

const answers = ref<Array<string | null>>([null, null, null]);

const updateAnswer = (value: string) => {
  answers.value[currentQuestion.value] = value;
  nextQuestion();
  validateSurvey();
};

const nextQuestion = () => {
  currentQuestion.value += 1;
};

const showRecommendedDevices = ref(false);
const validateSurvey = () => {
  if (isSurveyCompleted()) {
    logEvent(EventLogs.Events.SELF_SERVICE_SURVEY_USED);
    logAction(ActionLogs.Events.SELF_SERVICE_SURVEY_USE);
    recommendDevices();

    showRecommendedDevices.value = true;
  }
};

const isSurveyCompleted = () => {
  return answers.value.every((answer) => answer !== null);
};

const recommendedDevice = ref<IRecommendedDetailedDevice>();
const topRecommendedDevicesRef = ref<Array<IRecommendedDetailedDevice>>([]);

const showRecommendedDeviceSpecs = ref(false);
const showRecommendedDeviceSpecsLoader = ref(true);

const recommendDevices = async () => {
  const answerSpecs = surveyTransformerSpecs(Number(answers.value[1]));
  const answerPrice = surveyTransformerPrice(Number(answers.value[2]));
  const topFilteredDevices = await getRecommendedDevices(
    store.state.carts?.cartTag,
    answerSpecs,
    answerPrice
  );
  const topRecommendedDevices: Array<IRecommendedDetailedDevice> = [];
  let device: IRecommendedDetailedDevice;
  for (device of topFilteredDevices.data) {
    if (device?.makeModel) {
      try {
        const response = await getDeviceDetails(device.makeModel);
        if (response?.data) {
          device.imageFront = response.data?.imageFront;
          device.displayResolution = response.data?.displayResolution;
          device.ram = response.data?.ram;
          device.storage = response.data?.storage;
          device.cameraFront = response.data?.cameraFront;
          device.cameraBack = response.data?.cameraBack;
          device.battery = response.data?.battery;
        }
      } catch (error) {
        // Do not show error to user! (oscar)
        // Should I log as an action?
        // console.log({ error });
      }
    }

    topRecommendedDevices.push(device);
  }
  topRecommendedDevicesRef.value = topRecommendedDevices;

  recommendedDevice.value = topRecommendedDevices[0];
  const logData = {
    answerQ1: answers.value[0],
    answerQ2: answers.value[1],
    answerQ3: answers.value[2],
    manufacturer: recommendedDevice.value.manufacturer,
    makeModel: recommendedDevice.value.makeModel,
    description: recommendedDevice.value.description,
  };
  await logEvent(EventLogs.Events.SELF_SERVICE_SURVEY_RESULTS, logData);

  showRecommendedDeviceSpecsLoader.value = false;
  showRecommendedDeviceSpecs.value =
    recommendedDevice.value?.imageFront !== undefined;
};

const getMoreRecommendedDevices = computed((): IRecommendedDetailedDevice[] => {
  return topRecommendedDevicesRef.value.slice(1);
});

const changeRecommendedDevice = (index: number) => {
  const currentRecommendedDevice = recommendedDevice.value;
  const newRecommendedDevice = topRecommendedDevicesRef.value[index];

  recommendedDevice.value = newRecommendedDevice;
  if (currentRecommendedDevice) {
    topRecommendedDevicesRef.value.splice(index, 1, currentRecommendedDevice);
  }
  topRecommendedDevicesRef.value.splice(0, 1, newRecommendedDevice);
  showRecommendedDeviceSpecs.value =
    recommendedDevice.value?.imageFront !== undefined;
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

h1 {
  color: $pj-color-green;
  font-weight: bold;
  font-size: 2rem;
}

h1.card-title {
  color: $pj-color-black;
}

h6 {
  color: $pj-color-green;
}

p {
  font-size: 1.2em;
}

.card {
  border-style: none;
  background-color: $pj-color-chinook;
  background-image: url(/img/self-serve/curves.svg);
  background-size: cover;
  color: black;
  font-size: 1em;
  border-radius: 30px;
}

.btn-link-grey {
  color: $pj-color-gray;
  border: none;
}
.btn-success {
  font-weight: bold;
  color: $pj-color-white;
  background-color: $pj-color-green;
  border-color: $pj-color-green;

  &:hover {
    background-color: $pj-color-gray;
    border-color: $pj-color-gray;
  }

  &:focus {
    box-shadow: none;
  }
}
.btn-yellow {
  font-weight: bold;
  color: $pj-color-green;
  background-color: $pj-color-yellow;
  border-color: $pj-color-yellow;

  &:hover {
    color: $pj-color-white;
    background-color: $pj-color-gray;
    border-color: $pj-color-gray;
  }

  &:focus {
    box-shadow: none;
  }
}

.link-green {
  color: $pj-color-green;
  font-size: 1rem;

  a {
    text-decoration: none;
    color: $pj-color-green;
  }
}

.device-image {
  max-height: 500px;
  max-width: 25vw;
  width: auto;
  height: auto;
}

.secondary-device-image {
  max-height: 128px;
  max-width: 128px;
  width: auto;
  height: auto;
}

.device-spec {
  font-size: 1rem;
  font-weight: bold;

  img {
    height: 64px;
    padding: 6px;
  }
}
</style>
